import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnInit {

  @Input() list!: any[];
  @Input() title!: any;
  @Input() typeText: any = 'Filter By Type';

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareIndividualCheckedList = new EventEmitter();
  showDropDown: boolean = false;

  constructor() {
    this.checkedList = [];
  }

  ngOnInit(): void {
  }
  checkedList: any[];
  nameCheckedList: any[] = [];
  currentSelected!: {};

  getSelectedValue(status: Boolean, name: String, value:String) {
    if (status) {
      this.checkedList.push(name);
    } else {
      var index = this.checkedList.indexOf(name);
      this.checkedList.splice(index, 1);
    }

    this.currentSelected = { checked: status, name: name, value:value };

    //share checked list
    this.shareCheckedlist();

    //share individual selected item
    this.shareIndividualStatus();
  }
  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }
  shareIndividualStatus() {
    this.shareIndividualCheckedList.emit(this.currentSelected);
  }

}
